// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"social-module--wrapper--3v0Oj","title":"social-module--title--9R_KP","logosRow":"social-module--logosRow--3-Lo8","socialIcon":"social-module--socialIcon--w_8q9"};